<div class="ion-margin order">
  <ion-card class="border-r10 ion-no-margin ion-no-padding">
    <ion-item-group class="order-content">
      <ion-item
        class="order-item ion-bg-white ion-no-padding ion-padding-horizontal"
        lines="none"
      >
        <ion-thumbnail
          slot="start"
          class="ion-no-margin ion-no-vertical marr10"
        >
          <custom-icon
            iconName="ORDER_ICON"
            [width]="20"
            [height]="20"
          ></custom-icon>
        </ion-thumbnail>
        <ion-label
          class="fs-3 font600 ion-no-margin l-height19 card-primary-text-color"
        >
          {{ "shared.order_details.order_details" | translate }}
        </ion-label>
        <ion-chip
          *ngIf="paymentInfo['refundMessage']"
          class="ion-no-margin ion-no-padding ion-justify-content-center fs-1 font500"
          [ngClass]="
            paymentInfo['paymentStatus'] === 'refund_failed'
              ? 'grey-danger-chip'
              : 'grey-primary-chip'
          "
          >{{ paymentInfo["refundMessage"] }}
        </ion-chip>
      </ion-item>
      <hr />
      <ion-item
        class="order-item ion-bg-white ion-padding-horizontal marv10"
        *ngFor="let orderItem of orderDetails"
        lines="none"
      >
        <ion-thumbnail class="product-icon">
          <img class="border-r10 product-img" [src]="orderItem?.productImage" />
        </ion-thumbnail>
        <div class="padl10 mart4 marb5 product-header">
          <ion-label
            class="fs-3 font500 ion-no-margin marl10 product-title card-black-text-color"
            >{{ orderItem?.productTitile }}</ion-label
          >
          <span class="fs-3 font500 card-black-text-color product-item"
            >({{ orderItem?.quantity }}
            {{ "shared.order_details.item" | translate }})</span
          >
        </div>
        <ion-label
          class="fs-3 font500 ion-no-margin primary-price-color"
          slot="end"
        >
          <div>
            {{
              orderItem?.metaInfo?.finalPrice * orderItem?.metaInfo?.quantity
                | currency : currencyCode
            }}
          </div>
          <div
            class="fs-2 font500 text-striked strike-price-color ion-text-end"
            *ngIf="
              orderItem?.metaInfo?.origPrice &&
              orderItem?.metaInfo?.origPrice > orderItem?.metaInfo?.finalPrice
            "
          >
            {{
              orderItem?.metaInfo?.origPrice * orderItem?.metaInfo?.quantity
                | currency : currencyCode
            }}
          </div>
        </ion-label>
      </ion-item>
      <hr color="#ECECEC" size="2" width="92%" style="margin-top: 0px" />
      <ng-container *ngIf="salesSummary; else makeSalesSummary">
        <ng-container *ngFor="let item of salesSummary; let last = last">
          <ion-item
            [ngClass]="{ 'total-price': last }"
            class="order-item ion-bg-white ion-padding-horizontal"
            lines="none"
          >
            <ion-label
              class="fs-3 font600 ion-no-margin l-height19 card-black-text-color"
            >
              {{ item[0] }}
            </ion-label>
            <ion-label
              class="fs-3 font600 ion-no-margin card-black-text-color"
              slot="end"
            >
              {{ item[1] || 0 | currency : currencyCode }}
            </ion-label>
          </ion-item>
        </ng-container>
      </ng-container>
      <ng-template #makeSalesSummary>
        <div *ngIf="discountConfig && discountConfig?.saleDiscountAmount">
          <ion-item
            class="order-item ion-bg-white ion-padding-horizontal"
            lines="none"
          >
            <ion-label
              class="fs-3 font600 ion-no-margin card-tertiary-text-color"
            >
              {{ discountConfig?.saleDiscountText }}
            </ion-label>
            <ion-label
              class="fs-3 font600 ion-no-margin card-tertiary-text-color"
              slot="end"
            >
              -{{
                discountConfig?.saleDiscountAmount | currency : currencyCode
              }}
            </ion-label>
          </ion-item>
          <hr />
        </div>
        <div *ngIf="discountConfig && discountConfig?.productDiscountAmount">
          <ion-item
            class="order-item ion-bg-white ion-padding-horizontal"
            lines="none"
          >
            <ion-label class="fs-3 font600 ion-no-margin card-black-text-color">
              {{ discountConfig?.productDiscountText }}
            </ion-label>
            <ion-label
              class="fs-3 font600 ion-no-margin primary-price-color"
              slot="end"
            >
              -{{
                discountConfig?.productDiscountAmount | currency : currencyCode
              }}
            </ion-label>
          </ion-item>
          <hr />
        </div>
        <ion-item class="order-item ion-bg-white ion-padding-horizontal">
          <ion-label class="fs-3 font600 ion-no-margin card-black-text-color">
            {{ "shared.order_details.total_amount" | translate }}
          </ion-label>
          <ion-label
            class="fs-3 font600 ion-no-margin primary-price-color"
            slot="end"
          >
            {{ totalPrice | currency : currencyCode }}
          </ion-label>
        </ion-item>
        <div
          *ngIf="
            discountConfig && discountConfig?.promotionalDiscountAmount > 0
          "
        >
          <ion-item
            class="order-item ion-bg-white ion-padding-horizontal desc-text-color"
            lines="none"
          >
            <ion-label class="fs-3 font500 ion-no-margin">
              {{ discountConfig?.promotionalDiscountText }}
            </ion-label>
            <ion-label class="fs-3 font500 ion-no-margin" slot="end">
              -
              {{
                discountConfig?.promotionalDiscountAmount
                  | currency : currencyCode
              }}</ion-label
            >
          </ion-item>
          <hr />
        </div>
        <div *ngIf="discountConfig && discountConfig?.preOrderDiscountAmount">
          <ion-item
            class="order-item ion-bg-white ion-padding-horizontal"
            lines="none"
          >
            <ion-label class="fs-3 font600 ion-no-margin card-black-text-color">
              {{ discountConfig?.preOrderDiscountText }}
            </ion-label>
            <ion-label
              class="fs-3 font600 ion-no-margin primary-price-color"
              slot="end"
            >
              -{{
                discountConfig?.preOrderDiscountAmount | currency : currencyCode
              }}
            </ion-label>
          </ion-item>
          <hr />
        </div>
        <div *ngIf="discountConfig && discountConfig?.cartDiscountAmount">
          <ion-item
            class="order-item ion-bg-white ion-padding-horizontal desc-text-color"
            lines="none"
          >
            <ion-label class="fs-3 font600 ion-no-margin">
              {{ discountConfig?.cartDiscountText }}
            </ion-label>
            <ion-label class="fs-3 font600 ion-no-margin" slot="end">
              -{{
                discountConfig?.cartDiscountAmount | currency : currencyCode
              }}
            </ion-label>
          </ion-item>
          <hr />
        </div>
        <div *ngIf="campaignInfo && campaignInfo?.campaignDiscount">
          <ion-item
            class="order-item ion-bg-white ion-padding-horizontal"
            lines="none"
          >
            <ion-label
              class="fs-3 font600 ion-no-margin card-tertiary-text-color"
            >
              {{ campaignInfo?.campaignDiscountText }}
            </ion-label>
            <ion-label
              class="fs-3 font600 ion-no-margin card-tertiary-text-color"
              slot="end"
            >
              -{{ campaignInfo?.campaignDiscount | currency : currencyCode }}
            </ion-label>
          </ion-item>
          <hr />
        </div>
        <ion-item
          class="order-item ion-bg-white ion-padding-horizontal"
          lines="none"
        >
          <ion-label class="fs-3 font600 ion-no-margin card-black-text-color">
            {{
              paymentInfo.paymentStatus === "payment_init" ||
              paymentInfo.paymentStatus === "payment_failed"
                ? "shared.order_details.total_amount_to_be_paid"
                : ("shared.order_details.total_amount_paid" | translate)
            }}
          </ion-label>
          <ion-label
            class="fs-3 font600 ion-no-margin primary-price-color"
            slot="end"
          >
            {{ discountConfig?.totalPrice | currency : currencyCode }}
          </ion-label>
        </ion-item>
        <div *ngIf="paymentInfo['refundAmount'] != null">
          <hr />
          <ion-item
            class="order-item ion-bg-white ion-padding-horizontal"
            lines="none"
          >
            <ion-label class="fs-3 font600 ion-no-margin card-black-text-color">
              {{ "shared.order_details.total_refund" | translate }}
            </ion-label>
            <ion-label
              class="fs-3 font600 ion-no-margin primary-price-color"
              slot="end"
            >
              {{ paymentInfo.refundAmount | currency : currencyCode }}
            </ion-label>
          </ion-item>
        </div>
      </ng-template>
    </ion-item-group>
  </ion-card>
</div>
